import { LeadTimeAuditData, LeadTimeAuditDataExtended } from './../types';

export const transformLeadTimeData = (
  updates: LeadTimeAuditData[]
): LeadTimeAuditDataExtended[] => {
  return updates
    .map((update) => {
      return {
        ...update,
        productOptionLeadTimes: update.productOptionLeadTimes.filter(
          (productOption) =>
            productOption.changeStatus === 'Updated' ||
            productOption.changeStatus === 'Inserted'
        ),
      };
    })
    .filter(
      (update) =>
        update.changeStatus === 'Updated' ||
        update.changeStatus === 'Inserted' ||
        update.productOptionLeadTimes.length !== 0
    )
    .map((update) => {
      return {
        ...update,
        id: update.articleCode,
        leadTimeUpdate:
          update.oldLeadTimeValue !==
            update.newLeadTimeValue
            ? `${update.oldLeadTimeValue ?? ""} \u2192 ${update.newLeadTimeValue}`
            : update.oldLeadTimeValue
      };
    });
};
